/**
 * Copyright © Redbox Digital Limited. All rights reserved.
 */
 define('Magento_Checkout/js/minicart/minicart',[
    'jquery',
    'domReady!'
], function ($) {
    $.widget('tescomobile.minicart', {
        /**
         * Widget initialization
         * @private
         */
        _create: function () {
            this.minicartOldPriceStyler();
        },

        /**
         * Add specific class for basket tariff info section if ccp exist
         */
        minicartOldPriceStyler: function () {
            $( ".minicart-wrapper" ).on('click', function() {
                let minicartItemTotal = $("#mini-cart .item .item-totals .clubcard"),
                    minicartItemSummary = $("#mini-cart .item .item-summary .clubcard"),
                    minicartItemSummaryTariff = $("#mini-cart .item .item-summary .tariff-wrapper .clubcard");

                minicartItemTotal.each(function() {
                    $(this).prev().children('.value').addClass('old-price');
                });

                minicartItemSummary.each(function() {
                    $(this).prev().children('.value').addClass('old-price');
                });

                minicartItemSummaryTariff.each(function() {
                    $(this).parent().children('.usage').children('.value').addClass('old-price');
                });
            });
        }
    });

    return $.tescomobile.minicart;
});

